import React from 'react';
import AmountWizard from './AmountWizard';
import CartWizard from './CartWizard';
import EnvelopesWizard from './EnvelopesWizard';
import ThankYouWizard from './ThankYouWizard';
import { CheckoutWizardRouterProps } from './CheckoutWizardInterfaces';
import { useDonee } from '../../../../api';

const CheckoutWizardRouter: React.FC<CheckoutWizardRouterProps> = (props) => {
    const { donee } = useDonee();

    if (!donee) return null;

    switch (props.route) {
        case 'amount':
            return (
                <AmountWizard
                    {...props}
                    donee={donee}
                />
            );
        case 'envelopes':
            // important check: updating here will affect EnvelopesWizard component
            if (props.cart.envelopes['new']) {
                return (
                    <EnvelopesWizard
                        {...props}
                        donee={donee}
                    />
                );
            }
            props.setRoute('amount');
            return null;
        case 'cart':
            return <CartWizard {...props} />;
        case 'thank-you':
            return (
                <ThankYouWizard
                    {...props}
                    donee={donee}
                />
            );
    }
};

export default CheckoutWizardRouter;
